import { cartPerformance } from '@lib/performance';
import { fetchConfig, getSectionsToRender } from '@lib/section-utils';
import { CartDrawer } from '@lib/cart-drawer';
import { PUB_SUB_EVENTS, publish, shippingconversion, openDrawer, closeDrawer, overflowAdd, overflowRemove } from '@lib/pubsub';
export class ProductForm extends HTMLElement {
	constructor() {
		super();
		this.form = this.querySelector('form');
		var carddetailsHover = false;
	
		if (this.form) {
		  this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
		}
	
		this.cart = null;
		// Load cart drawer safely

		if (customElements.get('cart-drawer')) {
			this.cart = document.querySelector('cart-drawer');
		
			
		} else {
			customElements.whenDefined('cart-drawer').then(() => {
				this.cart = document.querySelector('cart-drawer');
				
			});
		}
		this.submitButton = this.querySelector('[type="submit"]');
		this.submitButtonText = this.submitButton?.querySelector('[data-button-text]');

		this.hideErrors = this.dataset.hideErrors === 'true';
	}
	
	onSubmitHandler(evt) {
		evt.preventDefault();
	  
		const bundleVariants = [...this.form.querySelectorAll('input[name="id"].product-variant-id[data-product-handle]')]
		  .map(input => ({
			id: input.value,
			quantity: 1
		  }));
	  
		const isBundle = bundleVariants.length >= 1;
	  
		/** ----------- NORMAL UI + BUTTON PREP ----------- **/
		if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
	  
		this.handleErrorMessage();
		const getPrevFocusElement = document.querySelector('.prev-focuse-element');
		if(getPrevFocusElement) getPrevFocusElement.classList.remove('prev-focuse-element');
	  
		this.submitButton.classList.add('prev-focuse-element');
		this.submitButton.setAttribute('aria-disabled', true);
	  
		if (this.submitButton.querySelector('[data-product-button]')) {
		  this.submitButton.querySelector('[data-product-button]').classList.add('hidden');
		  this.submitButton.insertAdjacentHTML('beforeend', `
			<span class="btn-loader" data-btn-loader>
			  <span class="svg-inside">
				<svg fill="currentColor" viewBox="0 0 24 24" class="icon-btn-loader">
				  <circle cx="4" cy="12" r="3">
					<animate id="spinner_jObz" begin="0;spinner_vwSQ.end-0.25s" attributeName="r" dur="0.75s" values="3;.2;3"/>
				  </circle>
				  <circle cx="12" cy="12" r="3">
					<animate begin="spinner_jObz.end-0.6s" attributeName="r" dur="0.75s" values="3;.2;3"/>
				  </circle>
				  <circle cx="20" cy="12" r="3">
					<animate id="spinner_vwSQ" begin="spinner_jObz.end-0.45s" attributeName="r" dur="0.75s" values="3;.2;3"/>
				  </circle>
				</svg>
			  </span>
			</span>
		  `);
		}
	  
		/** ----------- SEND AJAX ----------- **/
		const config = fetchConfig('javascript');
	  
		if (isBundle) {
		  config.headers['Content-Type'] = 'application/json';
		  config.body = JSON.stringify({
			items: bundleVariants,
			sections_url: window.location.pathname,
			sections: this.cart ? this.cart.getSectionsToRender().map(section => section.id) : undefined
		  });
		} else {
		  config.headers['X-Requested-With'] = 'XMLHttpRequest';
		  delete config.headers['Content-Type'];
	  
		  this.formData = new FormData(this.form);
	  
		  if (this.cart) {
			this.formData.append('sections', this.cart.getSectionsToRender().map(section => section.id));
			this.formData.append('sections_url', window.location.pathname);
			this.cart.setActiveElement(document.activeElement);
		  }
	  
		  config.body = this.formData;
		}
		
		fetch(`${Theme.routes.cart_add_url}`, config)
		  .then(response => response.json())
		  .then(response => {
	  
			/** ----------- ERROR HANDLING (same for both) ----------- **/
			if (response.status || response.errors) {
			  this.error = true;
			  publish(PUB_SUB_EVENTS.cartError, {
				source: 'product-form',
				productVariantId: isBundle ? null : this.formData.get('id') ? parseInt(this.formData.get('id')) : null,
				errors: response.errors || response.description,
				message: response.message,
			  });
			  if(response.description){
				this.handleErrorMessage(response.description);
			  }else{
				this.handleErrorMessage(response.errors);
			  }

			  return;
			}
	  
			/** ----------- SUCCESS FLOW ----------- **/
			publish(PUB_SUB_EVENTS.cartUpdate, {
			  source: 'product-form',
			  productVariantId: isBundle ? null : this.formData.get('id'),
			  cartData: response,
			});
	  
			if (this.cart && this.cart.classList.contains('is-empty')) {
			  this.cart.classList.remove('is-empty');
			}
	  
			setTimeout(() => {
			  openDrawer('cart');
			  overflowAdd();
			}, 100);
	  
			shippingconversion();
			this.cart?.renderContents(response);
		  })
		  .catch((e) => console.error(e))
		  .finally(() => {
	  
			this.submitButton.removeAttribute('aria-disabled');
			
			const loader = this.submitButton.querySelector('[data-btn-loader]');
			if (loader) loader.remove();
	  
			if (this.submitButton.querySelector('[data-product-button]')) {
			  this.submitButton.querySelector('[data-product-button]').classList.remove('hidden');
			}
		  });
	  }
	  
	handleErrorMessage(errorMessage = false, carddetailsHover) {
		if (this.hideErrors) return;
		this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('[data-error-wrapper]');
		if (!this.errorMessageWrapper) return;
		this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('[data-error-message]');
		this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
		this.errorMessageWrapper.classList.toggle('hidden', !errorMessage);

		if (errorMessage) {
			// Check if errorMessage is an object
			if (typeof errorMessage === 'object' && errorMessage !== null) {
				// Clear existing content
				this.errorMessage.innerHTML = '';
				// Add each error as a span element
				Object.values(errorMessage).forEach((error, index) => {
					if (error) {
						const errorSpan = document.createElement('span');
						errorSpan.textContent = `- ${error}`;
						this.errorMessage.appendChild(errorSpan);
					}
				});
			} else {
				// Display as regular text content
				this.errorMessage.textContent = errorMessage;
			}
			  setTimeout(() => {
					this.errorMessageWrapper.classList.add('hidden');
					
					if(carddetailsHover){
						this.submitButton.closest('[data-product-card]').classList.add('carddetails-onhover');
						//this.submitButton.closest('[data-product-card]').classList.remove('carddetails-always');
					}
				}, 4000);
		}
	}
	toggleSubmitButton(disable = true, text) {
		if (disable) {
			this.submitButton.setAttribute('disabled', 'disabled');
			if (text) this.submitButtonText.textContent = text;
		} else {
			this.submitButton.removeAttribute('disabled');
			this.submitButtonText.textContent = window.variantStrings.addToCart;
		}
	}
	get variantIdInput() {
		return this.form.querySelector('[name=id]');
	}

}
if (!customElements.get('product-form')) {
	customElements.define('product-form', ProductForm);
}